'use strict';

import { Entity } from '../Entity';

export class UserCompanyLogo extends Entity {
  protected companyLogoId;
  protected companyLogoName;

  protected user;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.companyLogoId = data.companyLogoId;
    this.companyLogoName = data.companyLogoName;
  }

  public getCompanyLogoId() {
    return this.companyLogoId;
  }

  public getCompanyLogoName() {
    return this.companyLogoName;
  }
}
